import { Page } from '#client/components/ui/Page';
import { PatientForm } from './PatientForm';

/** The lab's busiest data-entry screen. Reached from `/patients/new`. */
export function PatientRegistrationPage() {
  return (
    <Page
      title="Patient registration"
      subtitle="Register a patient and open their reports"
      fullWidth
    >
      <PatientForm />
    </Page>
  );
}
